/** @format */

import { InvalidResponse, ReviewSummary } from '../../model';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppProductReviewState } from '../reducers';

/**
 * @description
 * Handles each different scenario for product Reviews functionality
 */

export const selectProductReviewState =
	createFeatureSelector<AppProductReviewState>('productReviews');

export const selectProductReviewProductIdentifier = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.productIdentifier
);

export const selectProductReviewSummary = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.reviewSummary
);

export const selectProductReviewRating = createSelector(
	selectProductReviewSummary,
	(state) => (state as ReviewSummary).averageRating
);

export const selectProductReviewCount = createSelector(
	selectProductReviewSummary,
	(state) => (state as ReviewSummary).reviewCount
);

export const selectProductReviews = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.reviews
);

export const selectAIReviewSummary = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.aiReview
);

export const selectProductStatistics = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.statistics
);

export const selectProductIncludedInformation = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.product
);

export const selectProductReviewProsCons = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.prosCons
);

export const selectCurrentReview = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.currentReview
);

export const selectProductReviewsMultimedia = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.reviewsMultimedia
);

export const selectBVPixel = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsState.BVPixel
);

export const selectBVPixelisAvailable = createSelector(selectBVPixel, (bvPixel) =>
	!(bvPixel instanceof InvalidResponse) && bvPixel?.isBVPixelReady !== undefined ? bvPixel : null
);
